import { alpha, type TypeText } from "@mui/material";

export const textLight: Partial<TypeText> = {
  primary: alpha("#000000", 0.87), // 87% opacity
  secondary: alpha("#000000", 0.6), // 60% opacity
  disabled: alpha("#000000", 0.38), // 38% opacity
};
